import { memo, useMemo } from "react";

import { RenderResourceRowCellProps } from ".";
import IacManagementTableText from "../components/Text";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import IacManagementResourceCell from "../components/ResourceCell";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import useCellCopyAction from "../useCellCopyAction";

const IacManagementTableResourceRowCellType = memo((props: RenderResourceRowCellProps) => {
  const { row } = props;

  const copyAction = useCellCopyAction(ResourcesSuggestions.ResourceType, row.type);
  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IacManagementResourceCell {...props} actions={actions}>
      <IacManagementTableText columnId={IAC_MANAGEMENTS_TABLE_COLUMNS.RESOURCE_TYPE}>
        {row.type}
      </IacManagementTableText>
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellType.displayName = "IacManagementTableResourceRowCellType";

export default IacManagementTableResourceRowCellType;
